import React from 'react';
import styles from './Footer.module.css';
import SocialMediaLinks from '../SocialMediaLinks/SocialMediaLinks';

const Footer: React.FC = () => {
    return (
        <footer className={styles.footer}>
            <SocialMediaLinks />
            <p>© 2024 Mob Drama. All rights reserved.</p>
        </footer>
    );
};

export default Footer;
